const liff = {
    error: '',
    ready: true,
    init: async () => {},
    openWindow: async () => {},
    closeWindow: async () => {},
    shareTargetPicker: () => new Promise((resolve) => setTimeout(() => resolve({ status: 'success' }), 1000)),
    getDecodedIDToken: () => ({ phone_number: '0912345678' }),
    isLoggedIn: () => true,
    isInClient: () => true,
    getFriendship: async () => ({ friendFlag: true }),
    getProfile: async () => ({
        userId: 'U4f2d9f7d16276708e1542abd25f38ea3',
        displayName: '黃卷 Juan',
        statusMessage: 'じゅえん',
        pictureUrl:
            'https://profile.line-scdn.net/0hDLs-asbHG2NeVDCtltNlHC4EGAl9JUJxcDRVBWJWTAZgNloycTdVBmNSQVQxbVticjVSAG5QElRSR2wFQALnV1lkRlJiYFkycjBdgA'
    }),
    getAccessToken: () =>
        'eyJhbGciOiJIUzI1NiJ9.qdhsww8yctNtc2ypA0jP3w_52oErzl_v6Y67mAQuesKiHuiCn3uuE9qaaXE5QAzMo3jps_ZAF8EaGDtlLkDOpj0nXux7MAoR1rBkvG_rdjp6kQMrf4KC7XHHx1Py_TAYRYvuUNe_Yromm0T7umuk0gg1t9H72c7tUCMD8nxR094.RoK8NJ6V-sm0ffzVO8I6rW3qgHSMUk6nPA7dwGK3wAs'
};

export default liff;
